import { omit } from 'lodash';

const DOCUMENT_MAPPING_READONLY_FIELDS = ['__typename', 'order', 'document'];

// `documents` is a read-only relationship projection listed in ORDER_READONLY_FIELDS, so the save
// path has to read it off the order *before* `omit(priced, ORDER_READONLY_FIELDS)` strips the key.
//
// The returned `orderIds` is what keys UPSERT_ORDERS' delete_document_mappings, and it is empty
// whenever the edited list is not an array. That distinction is the whole point of this helper:
//
//   array (even empty) -> the user's desired list. Delete the order's mappings, insert these.
//   not an array       -> this order was fetched without the `documents` projection, so the real
//                         list is unknown. Delete nothing, insert nothing, leave the order alone.
//
// Collapsing the second case into `[]` is what wipes every attachment on the order, because the
// delete is keyed on order_id and does not care that the insert is empty. Orders reached through a
// fallback like CompletedOrders' `data?.result || order` come from a fragment that selects no
// `documents`, which is exactly that case.
export const buildDocumentsSavePayload = ({ documents, orderId }) => {
    if (!Array.isArray(documents)) {
        return { documents: [], orderIds: [] };
    }

    return {
        documents: documents.map((mapping) => ({
            ...omit(mapping, DOCUMENT_MAPPING_READONLY_FIELDS),
            // New rows checked in AdditionalDocuments carry no order_id until the order
            // exists; mapping_id is left alone so an existing row keeps its identity
            // across the delete/re-insert.
            ...(orderId ? { order_id: orderId } : {}),
        })),
        orderIds: orderId ? [orderId] : [],
    };
};
